
import React from 'react';

const MySubmissionsHeader = () => {
  return (
    <div className="text-center space-y-3">
      <h1 className="text-3xl font-bold">My Submissions</h1>
      <p className="text-muted-foreground">
        Track the status of your terrace submissions
      </p>
    </div>
  );
};

export default MySubmissionsHeader;
